import React, { useState, useEffect } from 'react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
import { Combobox } from '@headlessui/react'
import { BsPersonFill } from 'react-icons/bs'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function DropdownWithImage({options, onChange, value, label}) {
  const [query, setQuery] = useState('')
  const [selectedPerson, setSelectedPerson] = useState(null)
  const [currentlySearching, setCurrentlySearching] = useState(false)

  useEffect(() => {
    findOptionFromValue()
  }, [])

  useEffect(() => {
    findOptionFromValue()
  }, [value])

  const interemediateOnChange = (value) => {
    const person = options.find((person) => person.value === value)
    setSelectedPerson(person)
    onChange(value)
  }

  const findOptionFromValue = () => {
    const person = options.find((person) => person.value === value)
    setSelectedPerson(person)
  }

  const emptyInputOnClick = () => {
    setQuery('')
    setSelectedPerson(null)
    setCurrentlySearching(true)
  }

  const filteredPeople =
    query === ''
      ? options
      : options.filter((person) => {
          return person.name.toLowerCase().includes(query.toLowerCase())
        })

  return (
    <Combobox as="div" value={selectedPerson} onChange={(e) => interemediateOnChange(e)}>
      {label && <Combobox.Label className="block text-sm font-medium leading-6 text-gray-900">{label}</Combobox.Label>}
      <div className="relative w-full mt-2">
        {(!currentlySearching && selectedPerson) ? <img alt="" className="absolute top-1.5 left-1 h-6 w-6 flex-shrink-0 rounded-full" src={selectedPerson?.imageUrl} /> : <BsPersonFill color='#94A3B8' className="absolute top-1.5 bg-gray-200 left-1 h-4 w-4 p-1 flex-shrink-0 rounded-full" />}
        <Combobox.Input
          onFocus={() => emptyInputOnClick()}
          onBlur={() => setCurrentlySearching(false)}
          className="w-full rounded-md border-0 bg-white py-1.5 pl-8 pr-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset  sm:text-sm sm:leading-6"
          onChange={(event) => setQuery(event.target.value)}
          displayValue={(person) => person ? person.name : 'Unassigned'}
        />
        <Combobox.Button className="absolute inset-y-1 inset-r-1 mr-1  right-[-42px] flex items-center bg-white border-0 rounded-r-md px-2 focus:outline-none">
          <ChevronUpDownIcon className="h-5 w-5 -z-0 text-gray-400" aria-hidden="true" />
        </Combobox.Button>

        {filteredPeople.length > 0 && (
          <Combobox.Options className="absolute z-10 m-0 max-h-56 p-0 list-none w-auto overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
            {filteredPeople.map((person) => (
              <Combobox.Option
                key={person.id}
                value={person.value}
                className={({ active }) =>
                  classNames(
                    'relative cursor-default select-none pl-5 pr-14 py-2',
                    active ? 'bg-indigo-600 text-white' : 'text-gray-900'
                  )
                }
              >
                {({ active, selected }) => (
                  <>
                    <div className="flex items-center">
                      <img src={person.imageUrl} alt="" className="h-6 w-6 flex-shrink-0 rounded-full" />
                      <span className={classNames('ml-3 truncate', selected && 'font-semibold')}>{person.name}</span>
                    </div>

                    {selected && (
                      <span
                        className={classNames(
                          'absolute inset-y-0 right-0 flex items-center pr-4',
                          active ? 'text-white' : 'text-indigo-600'
                        )}
                      >
                        <CheckIcon className="h-5 w-5" aria-hidden="true" />
                      </span>
                    )}
                  </>
                )}
              </Combobox.Option>
            ))}
          </Combobox.Options>
        )}
      </div>
    </Combobox>
  )
}